import React from 'react';
import { HashtagIcon } from '@revfluence/fresh-icons/regular/esm';

export const StyledHashtagIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>((props, ref) => (
  <HashtagIcon
    {...props}
    ref={ref}
    style={{
      width: '42px',
      height: '48px',
      color: '#CBD1D7',
      marginBottom: '24px',
      ...props.style,
    }}
  />
));

StyledHashtagIcon.displayName = 'StyledHashtagIcon';
